/**
 * Home
 * 
 */

var home = new (function(){

    var that = this;
    
    this.init = function(){
        var bannerhome = $('.wrappb1');
            

        bannerhome.owlCarousel({
            items:1,
            loop:false,
            dots:false,
            nav:true,
            animateOut: 'fadeOut', 
        }); 
        
        
   
    };

})();